import React, { useState } from "react";
import { useLang } from "../contexts/LangContext";
import { t } from "../i18n/translations";
import { Waves, Disc3 } from "lucide-react";

const BG = "https://customer-assets-rejwkqb3.emergentagent.net/job_massage-portal-6/artifacts/h7tz9fog_Gemini_Generated_Image_djnyvedjnyvedjny.webp";
const BOWL_LOG = "https://customer-assets-rejwkqb3.emergentagent.net/job_massage-portal-6/artifacts/t2g34tz7_Gemini_Generated_Image_oyotgdoyotgdoyot.webp";
const MED = "https://customer-assets-rejwkqb3.emergentagent.net/job_massage-portal-6/artifacts/j7zemrbg_Gemini_Generated_Image_ktltbmktltbmktlt.webp";

export default function Klangschalen() {
  const { lang } = useLang();
  const benefits = t(lang, "klangschalen.benefits") || [];

  return (
    <div data-testid="klangschalen-page">
      {/* Hero */}
      <section className="relative h-[60vh] min-h-[400px] overflow-hidden">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/60 via-ink/40 to-background" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-12 h-full flex flex-col justify-end pb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-sand mb-4">— {t(lang, "klangschalen.subtitle")}</div>
          <h1 className="font-display text-5xl lg:text-7xl text-sand leading-tight max-w-3xl">{t(lang, "klangschalen.title")}</h1>
        </div>
      </section>

      {/* Intro */}
      <section className="max-w-4xl mx-auto px-6 lg:px-12 py-20">
        <p className="text-xl font-display text-ink leading-relaxed text-balance">{t(lang, "klangschalen.lead")}</p>
      </section>

      {/* Quote */}
      <section className="bg-muted/60 border-y border-border py-16">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <Disc3 className="w-7 h-7 text-terracotta mx-auto mb-5" strokeWidth={1.5} />
          <blockquote className="font-display text-3xl lg:text-4xl text-ink italic">«{t(lang, "klangschalen.quote")}»</blockquote>
          <p className="mt-5 text-sm text-ink-muted tracking-wide">{t(lang, "klangschalen.origin")}</p>
        </div>
      </section>

      {/* Effects grid */}
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="aspect-[4/5] rounded-md overflow-hidden bg-muted">
            <img src={BOWL_LOG} alt="" className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="lg:col-span-7 lg:pt-6">
          <h2 className="font-display text-4xl text-ink leading-tight">{t(lang, "klangschalen.effect_title")}</h2>
          <p className="mt-6 text-ink-muted leading-relaxed">{t(lang, "klangschalen.effect_body")}</p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3" data-testid="klangschalen-benefits">
            {benefits.map((b, i) => (
              <li key={i} className="flex gap-3 text-sm text-ink">
                <Waves className="w-4 h-4 text-sage mt-1 shrink-0" strokeWidth={1.5} />
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* During massage */}
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-24 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7 lg:pt-6 order-2 lg:order-1">
          <h2 className="font-display text-4xl text-ink leading-tight">{t(lang, "klangschalen.massage_title")}</h2>
          <p className="mt-6 text-ink-muted leading-relaxed">{t(lang, "klangschalen.massage_body")}</p>
        </div>
        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="aspect-[4/5] rounded-md overflow-hidden bg-muted">
            <img src={MED} alt="" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
    </div>
  );
}
